module.exports = __webpack_public_path__ + "static/img/FuZhuang_Banner.6f31b872.jpg";